ko.bindingHandlers.resizeSelect = (() =>
{

    const resizeByWidth = (e) =>
    {
        
        const elem = e.currentTarget as HTMLSelectElement
        const selected = elem.options[elem.selectedIndex]
        //const selected = elem.querySelector('option:selected');

        const dummy = document.createElement('SELECT')
        dummy.classList.add(...elem.classList);

        const dummyOption = document.createElement('OPTION') as HTMLOptionElement;
        dummyOption.textContent = selected?.textContent || null;

        dummy.appendChild(dummyOption);

        document.body.appendChild(dummy)

        elem.style.width = dummy.clientWidth + 5 + 'px';
        elem.style.opacity = '1'

        dummy.remove()
    }

    const _resize = (elem: HTMLSelectElement, value, allbindingsAccessor) =>
    {
        //don't do on mobile. Most mobile UI does not get better
        if (window.innerWidth < 400) return 
        elem.style.transition = 'width ease .2s';
        elem.style.width = '100px';

        setTimeout(() =>
        {
            resizeByWidth({ currentTarget: elem });
        }, 500);
        //to be sure
        setTimeout(() =>
        {
            resizeByWidth({ currentTarget: elem });
        }, 1500);
       
        elem.addEventListener('change', resizeByWidth, false);
        elem.addEventListener('blur', resizeByWidth, false);


        ko.utils.domNodeDisposal.addDisposeCallback(elem, () =>
        {
            //elem.removeEventListener('load', resizeSelect);
            elem.removeEventListener('change', resizeByWidth);
            elem.removeEventListener('blur', resizeByWidth);
            //elem.removeEventListener('focus', restoreSelect);
        });
    }

    return {
        init: _resize
    }
})();


/*ko.bindingHandlers.resizeSelect = {
    init: function (elem)
    {
        let sel = elem;
        function resizeSelect(selected)
        {
            if (resized) return;
            var sel = document.getElementById('select');
            for (var i = 0; i < sel.options.length; i++) {
                sel.options[i].title = sel.options[i].innerHTML;
                if (i != sel.options.selectedIndex) sel.options[i].innerHTML = '';
            }
            sel.blur();
        }

        //$.fn.resizeselect = function (settings)
        //{
        //    var arrowWidth = 30;
        //    return this.each(function ()
        //    {

        //        $(this).change(function ()
        //        {
        //            var $this = $(this);

        //            // create test element
        //            var text = $this.find("option:selected").text();
        //            var $test = $("<span>").text(text).css({
        //                "font-size": $this.css("font-size"), // ensures same size text
        //                "visibility": "hidden"               // prevents FOUC
        //            });


        //            // add to parent, get width, and get out
        //            $test.appendTo($this.parent());
        //            var width = $test.width();
        //            $test.remove();

        //            // set select width
        //            $this.width(width + arrowWidth);

        //            // run on start
        //        }).change();

        //    });
        //};
        setTimeout(() =>
        {
            resizeSelect(elem) //.resizeselect();

        }, 8000);

        resizeSelect(elem);

        //$(elem).resizeselect();
    },
    update: function (elem)
    {

        let sel = elem;


        function resizeSelect(selected)
        {
            if (resized) return;
            var sel = document.getElementById('select');
            for (var i = 0; i < sel.options.length; i++) {
                sel.options[i].title = sel.options[i].innerHTML;
                if (i != sel.options.selectedIndex) sel.options[i].innerHTML = '';
            }
            sel.blur();

        }
        resizeSelect(elem);
        //$(elem).resizeselect();

    }
}*/